import type { ContextDomain } from './RenderContext';

/**
 * Builds the `domain` context entity, so every `{domain.*}` token resolves in
 * any CMS text field on any page type. It has two independent sources:
 *
 *  - the render-page response's shell phone pair — the backend's 70.07 chain
 *    result, the same numbers the header shows: the location's own on Location
 *    Pages, otherwise the Page's own `phone` where an editor set one and the
 *    Domain Setting's phone elsewhere. A Page with `showPhoneNumber` off
 *    resolves no pair at all;
 *  - `placeholders`, the editor-maintained per-brand list the website fetches
 *    and caches itself (`getDomainPlaceholders`), which **wins** over the pair
 *    above — see spec 70.11-Domain-Placeholders.
 *
 * Returns `undefined` only when neither source has anything, so a brand with
 * placeholders but no resolved phone still gets an entity.
 */
export function domainEntityOf(
  response:
    | {
        resolvedPhone?: string;
        resolvedMatelsoPhoneLabel?: string;
      }
    | null
    | undefined,
  placeholders?: Record<string, string> | undefined,
): ContextDomain | undefined {
  const hasPlaceholders =
    !!placeholders && Object.keys(placeholders).length > 0;
  if (
    !response?.resolvedPhone &&
    !response?.resolvedMatelsoPhoneLabel &&
    !hasPlaceholders
  ) {
    return undefined;
  }
  return {
    phone: response?.resolvedPhone,
    matelsoPhoneLabel: response?.resolvedMatelsoPhoneLabel,
    ...(hasPlaceholders ? { placeholders } : {}),
  };
}
